<template>
    <div class="breadcrumb">

            <!--<div class="breadcrumb-text">当前位置：</div>-->
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-list">
                <el-breadcrumb-item :to="'/'" ><i class="el-icon-s-home"></i><span style="cursor: pointer;">首页</span></el-breadcrumb-item>
                <!--<el-breadcrumb-item :to="index!==vuexbreadcrumb.name.length-1 ? subStr(vuexbreadcrumb.path) : ''" v-for="(item,index) in vuexbreadcrumb.name" :key="index">-->
                    <!--{{item}}-->
                <!--</el-breadcrumb-item>-->
            </el-breadcrumb>

    </div>
</template>

<script>
    export default {
        name:"breadcrumb",  //首页
        data() {
            return {
                
            };
        },

        methods: {
            subStr(str){
                return str.substring(0,str.length-7)
            }
        },
        components: {
            
        },
        computed:{

        },
        watch:{

        }, // $route(){
        //     this.$store.commit('setCurrent',{
        //         path:this.$route.path,
        //         name:this.$route.name
        //     });
        // }
        mounted(){
            // this.$store.commit('setCurrent',{
            //     path:this.$route.path,
            //     name:this.$route.name
            // });
            
        }
    };
</script>

<style scoped>
    .breadcrumb{
        height: 38px;
        background-color: #DBEFFF;
    }
    .breadcrumb-bg{
        display:flex;
        /* margin-top:12px; */
        /* background-color:#e4e4e4; */
        padding:8px;
    }
    .breadcrumb-list{
        line-height:38px;
        margin-left: 30px;
    }
    .breadcrumb-text{
        height:16px;
        font-size:14px;
        color: #000;
        margin:initial;
    }

</style>  